import { safeTrack } from "./track";
import { PAGE_KEYS } from "./pageKeys";

export function trackCouponListView({ tab, pagePath, pageKey = PAGE_KEYS.COUPON_CENTER }) {
  return safeTrack("coupon_list_view", {
    page: pagePath || "",
    properties: {
      page_key: pageKey,
      tab,
    },
  });
}
